export default {
    path: 'agreement',
    component: () => import('@/pages/agreement/Agreement'),
}